import { Component, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';
import { MenuService } from '../menu/menu.service';
import { AppGlobal } from 'src/app/shared/app.global';
import { LoginService } from 'src/app/shared/services/login.service';
import { MemberService } from 'src/app/shared/services/member.service';
import { TokenService } from 'src/app/shared/services/token-service';
import { OrgService } from 'src/app/shared/services/org.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { UserOrg } from 'src/app/shared/services/userorg.service';
import { LocationService } from 'src/app/shared/services/location.service';
import { Router } from '@angular/router';
// import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
// import { ToastrService } from 'ngx-toastr';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { RoleService } from 'src/app/shared/services/role.service';
// import { EnvService } from 'src/app/env.service';
import { NotifyService } from 'src/app/shared/services/notificaton.service';
import { ToastrService } from 'ngx-toastr';
import { EnvService } from 'src/app/env.service';
declare var $: any
@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  providers: [MenuService, AppGlobal, MenuService, NotifyService, LoginService, MemberService, TokenService, OrgService, AuthService, UserOrg, LocationService],

  encapsulation: ViewEncapsulation.None
})
export class UserMenuComponent implements OnInit {

  //VARIABLES DECLARATIONS 

  public orgLogo;
  public token: any;
  public fb_token: any;
  public userId: any;
  public userMsisdn: any;
  public userType: any;
  public userName: any;
  public userLevel: any;
  public userSession: Array<any> = [];
  public userTime: Array<any> = [];
  public lastLoggedIn: Array<any> = [];
  orgList: any = [];
  delete_org_Id: any;
  changed_org_id: string;
  public org_id;
  public memId;
  imagepath;
  Count;
  nameRole: string;
  // notification
  public counters = 0;
  notification: any = [];
  messages = [];
  notification_ids = [];
  public orgName;
  public smallLogo: any;
  Dummy: string;
  counterBack: any;
  public modalRef: NgbModalRef;
  public isOpen;
  isMember: boolean;
  public memList: any;
  public showHorizontalMenu: boolean = true;
  public showInfoContent: boolean = false;
  public settings: Settings;
  public menuItems: Array<any>;
  public counter: any;
  whichapp: any = ""
  constructor(

    private loginService: LoginService,
    private memServ: MemberService,
    private tokenService: TokenService,
    private orgService: OrgService,
    private role: RoleService,
    private authService: AuthService,
    private router: Router,
    public userOrg: UserOrg,
    public config: AppGlobal,
    private locService: LocationService,
    private envService: EnvService,
    public modalService: NgbModal,
    private notifyService: NotifyService,
    public appSettings: AppSettings, public menuService: MenuService,
    // public toastr: ToastrService,


  ) {
    this.whichapp = this.envService.APP_NAME;
    this.smallLogo = this.config.SMALL_LOGO;
    this.Dummy = this.config.DUMMY_USER;
    this.settings = this.appSettings.settings;
    this.menuItems = this.menuService.getHorizontalMenuItems();
    this.isOpen = false;
  }
  ngOnInit() {
    // user details
    this.getUserDetails();
    this.whichapp = this.envService.APP_NAME;
    this.nameRole = this.tokenService.getRoleAccessName();
    if (this.nameRole !== 'Owner' && this.nameRole !== 'Admin') {
      this.isMember = true;
    }
    //activeclass
    $(".btnn2").click(function () {
      $(".btnn2").removeClass("active");
      $(this).addClass("active");
    });
    $('#myDD').on('hide.bs.dropdown', function (e) {
      if (e.clickEvent) {
        e.preventDefault();
      }
    });
    // check for session status
    this.getSessionStatus();

    // get user org
    this.orgName = this.userOrg.getOrgName();
    this.orgLogo = this.userOrg.getOrgImageUrl();
    if (this.org_id === null) {
      this.getUserOrg();
    }

    this.setToken();

    jQuery('#messagesTabs').on('click', '.nav-item a', function () {
      setTimeout(() => jQuery(this).closest('.dropdown').addClass('show'));
    });

    setInterval(() => {
      this.setToken();

    }, 600000);

  }

  // GET USER DETAILS
  getUserDetails() {
    // get user org

    const orgID = this.userOrg.getOrg();
    this.org_id = orgID;
    // if active get userdata
    const userdata = this.tokenService.getToken();
    if (userdata != null) {
      const tokendata = userdata.split('|');
      this.userMsisdn = tokendata[0];
      this.userId = tokendata[1];
      this.token = tokendata[2];
      this.userType = tokendata[3];
      this.userName = tokendata[4];
      this.userLevel = tokendata[5];
      this.fb_token = tokendata[7];
      this.imagepath = tokendata[8];
    }
    this.listMemInvitations();
  }
  // check for session status
  getSessionStatus() {
    this.authService.isAuthenticated(this.userId, this.token).subscribe((data: any) => {
      if (data.rescode === 2) {
        // this.toastr.info('Session expired', 'Alert!');
        this.tokenService.removeToken();
        this.router.navigate(['/accounts']);
      }
    });
  }
  // set Firebase Token
  setToken() {
    this.notifyService.getToken(this.token, this.userId, this.userType).subscribe((data: any) => {
      if (data.rescode === 1) {
        localStorage.setItem('firebase_token', JSON.stringify(data.data.firebase_custom_token));
      }
    });
  }


  public closeSubMenus() {
    let menu = document.querySelector("#menu0");
    if (menu) {
      for (let i = 0; i < menu.children.length; i++) {
        let child = menu.children[i].children[1];
        if (child) {
          if (child.classList.contains('show')) {
            child.classList.remove('show');
            menu.children[i].children[0].classList.add('collapsed');
          }
        }
      }
    }
  }

  @HostListener('window:resize')
  public onWindowResize(): void {
    if (window.innerWidth <= 768) {
      this.showHorizontalMenu = false;
    }
    else {
      this.showHorizontalMenu = true;
    }
  }

  // get user organization detail
  getUserOrg() {
    this.orgService.viewUserOrganization(this.token, this.userId).subscribe((data: any) => {
      if (data.rescode === 1) {
        this.orgList = data.data;
        // console.log(this.orgList)
        const org = this.userOrg.getOrg();
        if (org == null) {
          this.setUserOrg(data.data[0].org_id, data.data[0].org_name, data.data[0].org_logo, data.data[0].org_industry_id);
        }
      }
    });
  }


  // set user organziation name
  setUserOrgName(name: string) {
    this.userOrg.setOrgName(name);


  }

  UpdateUserOrg(item) {
    this.setUserOrg(item.org_id, item.org_name, item.org_logo, item.org_industry_id);
    window.location.reload();
    // this.router.navigate(['/views/organization/detail', item.org_id]);
   
  }

  // Set organization detail
  setUserOrg(id: string, name: any, Url: any, OrgType: any) {
    this.userOrg.setOrgImageUrl(Url);
    this.userOrg.setOrg(id);
    this.setUserOrgName(name);
    this.userOrg.setOrgType(OrgType);
    this.getUserDetails();
    this.changed_org_id = id;
    this.tokenService.removeRoleAccess();
    this.tokenService.removeRoleAccessName();
    this.setRoleAccess();
  }
  // Open Delete Modal
  deleteOpen(content, id) {
    this.delete_org_Id = id;
    this.modalRef = this.modalService.open(content, { centered: true, size: 'sm', backdrop: false });

  }
  /*  Delete Organization */
  deleteOrganization() {
    this.orgService.deleteOrganization(this.delete_org_Id, this.token, this.userId).subscribe((data: any) => {
      if (data.rescode === 1) {
        // this.toastr.success(data.message, 'Success');
        this.modalRef.close();
        this.userOrg.removeOrg();
        this.userOrg.removeOrgName();
        this.getUserOrg();

        // location.reload(true);

      } else {
        // this.toastr.error(data.message, 'Alert!');
      }
    });
  }

  setRoleAccess() {
    let items: any = [];
    let menuItems: any = [];
    this.role.getmoduleAccess(this.token, this.userId, this.org_id, this.whichapp, this.memId).subscribe((data: any) => {
      if (data.rescode === this.config.SUCCESS_CODE) {

        for (let i = 0; i < data.data.length; i++) {
          menuItems[i] = data.data[i].MenuDetail;
        }
        for (let i = 0; i < data.extra.Permissions.length; i++) {
          items[i] = data.extra.Permissions[i];
        }
        this.menuItems = this.role.generateMenuItems(menuItems);
        this.tokenService.setMenuItems(this.menuItems);
        this.tokenService.setRoleAccess(items);
        this.tokenService.setRoleAccessName(data.extra.RoleDetail.role_name);
        localStorage.setItem('reload_id', '1')

        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
          this.router.navigate(['/views/organization/detail/' + this.changed_org_id]));
          console.log("hello i'm here ")
      }

    });

  }


  // user login function
  getUserLogin(): void {
    this.loginService.sessionDetail(this.userId, this.userType).subscribe((res: any) => {
      if (res.data.length > 0) {
        this.userSession = res.data[0].lastloggedin;
      }
    },
      error => {
        // this.toastr.warning('Request Failed', 'User Session!');
      });
  }
  // Modal Logout
  public LogoutUser(sessionContent) {
    this.modalRef = this.modalService.open(sessionContent, { centered: true, size: 'sm', backdrop: false });
  }

  // LOGOUT 
  logout() {

    this.loginService.logout(this.userId, this.userType).subscribe((res: any) => {
      this.closeModal();
      clearInterval(this.counterBack);
      this.tokenService.removeToken();
      this.userOrg.removeOrg();
      this.userOrg.removeOrgName();
      this.userOrg.removeOrgImageUrl();
      this.tokenService.removeRoleAccess();
      this.tokenService.removeRoleAccessName();
      this.router.navigate(['/login']);
    },
      error => {
        // this.toastr.warning('Request Failed', 'Logout');
        this.router.navigate(['/login']);
      });
  }


  public closeModal() {
    this.modalRef.close();
  }
  stayLogin() {
    this.tokenService.setSessionTime();
    clearInterval(this.counterBack);
    this.closeModal();
  }

  // onCLick notification
  async onClickNote() {
    if (!this.isOpen) {
      this.isOpen = true;
      this.getNotifcation();
      this.listMemInvitations()
    } else {
      this.isOpen = false;
    }

  }
  public sessionTime(): void {

    this.loginService.sessionTime(this.userId, this.userType).subscribe((res: any) => {
      if (res.data.length > 0) {
        this.userTime = res.data;
      }

    },
      error => {

        // this.toastr.warning('Request Failed', 'User Session!');

      });

  }
  // display new notification
  displayNewNotification() {
    this.notifyService.getNotify(this.token, this.userId).subscribe((data: any) => {
      if (data.rescode === 1) {
        const newmessages = data.data;
        // this.spinner.hide();
        for (let i = 0; i < this.notification.length; i++) {
          if (this.notification[i].id === newmessages[i].notification_id) {
          }
        }
      }
    });
  }
  getMessages(data: any): any[] {
    for (let i = 0; i < data.length; i++) {
      const messages = [];

      messages.push({
        notification_id: data[i].notification_id,
        notification_status: data[i].notification_status,
        notification_text: data[i].notification_text,
        notification_title: data[i].notification_title,
        notification_type: data[i].notification_type,
        notification_udt: data[i].notification_udt
      });
      return messages;
    }
  }
  //  get notificaation list
  getNotifcation() {

    // this.spinner.show();
    this.notifyService.getNotify(this.token, this.userId).subscribe((data: any) => {

      if (data.rescode === 1 || data.rescode === 0) {
        this.messages = data.data;
        // ('hello:', this.messages);
        // this.spinner.hide();
        // get pending notifications

        for (let i = 0; i < data.data.length; i++) {
          const notification_ids = [];
          if (data.data[i].notification_status === 4) {
            notification_ids.push({
              notification_id: data.data[i].notification_id,
              notification_status: data.data[i].notification_status,
            });
            this.changeNotificationStatus(notification_ids);
          }
        }
      } else {
        // this.spinner.hide();
      }

    });
  }
  listMemInvitations(): void {
    this.memServ.listInvitationMem(this.token, this.userId).subscribe((data: any) => {
      if (data.rescode === 1 || data.rescode === 0) {
        this.memList = data.data;
        // console.log(this.memList)
        // this.imageSrc = data.data.org_logo;
      } else {
        //   this.toastr.error(data.message, 'Alert!');
      }
    });
  }

  // reloadPage() {
  //   window.location.reload();
  // }  

  // change notification status
  changeNotificationStatus(notifications) {
    this.notifyService.changeNotificationStatus(this.token, this.userId, this.userType, notifications).subscribe((data: any) => {
      if (data.rescode === 1) {
        //  this.toastr.info('status changed');
      } else {
        //  this.toastr.error('Status change failed');
      }
    });
  }
  // Accept Invitations Org
  accpetInvitation(invitedID: any): void {
    this.memServ.acceptMemIvitation(this.token, this.userId, invitedID).subscribe((data: any) => {
      if (data.rescode === 1) {
        this.listMemInvitations();
        // this.toastr.success(data.message, 'SUCCESS!');
      } else {
        // this.toastr.error(data.message, 'Alert!');
      }
    });
  }

  // Reject Invitations Org
  rejectInvitation(invitedID: any): void {
    this.memServ.rejectMemIvitation(this.token, this.userId, invitedID).subscribe((data: any) => {
      if (data.rescode === 1) {
        this.listMemInvitations();
        // this.toastr.success(data.message, 'SUCCESS!');
      } else {
        // this.toastr.error(data.message, 'Alert!');
      }
    });
  }
  openVerticallyCentered(content) {
    this.modalRef = this.modalService.open(content, {
      centered: true, backdrop: 'static',
      keyboard: false
    });
  }

  // get notification count
  // getCount() {
  //   const firebase_token = JSON.parse(localStorage.getItem('firebase_token'));
  //   this.afAuth.auth.signInWithCustomToken(firebase_token)
  //     .then(value => {
  //       const uid = value.user.uid;
  //       this.db.list('/users/' + uid + '/notifications').snapshotChanges().subscribe(async (data) => {
  //         this.Count = 0;
  //         this.notification = [];
  //         let i = 0;
  //         for (const val of data) {
  //           this.notification.push({
  //             id: parseInt(val.payload.key),
  //           });
  //           i++;
  //         }
  //         this.Count = this.notification.length;
  //         await this.displayNewNotification();
  //       });
  //     })
  //     .catch(err => {
  //     });
  // }
}